import React from "react";
import Listings from "../components/Listings";
import { useAuth } from "../auth/AuthContext";
import { useTranslation } from "react-i18next";
import HomeButton from "../components/HomeButton";

export default function MyListings() {
  const { user } = useAuth();
const { t } = useTranslation();

  if (!user) {
    return <p>{t("auth.not_logged")}</p>;
  }

  return (
    <div style={{ padding: 20 }}>
      <HomeButton/>
        <h1>{t("profile.my_listings")}</h1>

      <Listings
        filter={{ userId: user.uid }}
      />
    </div>
  );
}
